// extracted by mini-css-extract-plugin
module.exports = {"input":"index_input__2AxOU","autoComplete":"index_autoComplete__GFGR5","tags":"index_tags__3CCrA","tag":"index_tag__2Sujz"};